import Cookie from "js-cookie";

import { YANDEX_METRICS_ID } from "../../helpers/metrics";

export const registration = () => {
  // Facebook
  window.fbq && window.fbq("track", "CompleteRegistration");
  // Yandex
  window.yaCounter24094609 && window.yaCounter24094609.reachGoal("reg");
  // GA 4
  window.dataLayer && window.dataLayer.push({ event: "registration" });
};

export const partnerRegistration = () => {
  window.yaCounter24094609 && window.yaCounter24094609.reachGoal("new_partner");

  window.dataLayer && window.dataLayer.push({ event: "registration_partner" });
};

export const saveLastRef = location => {
  const ref = location.search + location.hash;
  if (ref) {
    Cookie.set("ref", ref, { expires: 30 });
  }
};

export const setUserId = userId => {
  window.ym && window.ym(YANDEX_METRICS_ID, "setUserID", userId);
  window.ga && window.ga("set", "userId", userId);
  window.dataLayer &&
    window.dataLayer.push(["config", "G-QBM958ZHNC", { user_id: userId }]);
};

export const onExpertViewOpenYandex = () => {
  window.yaCounter24094609 &&
    window.yaCounter24094609.reachGoal("perehod-ekspertnyi-rezhim");
};

export const onOpenTenderByNumberYandex = () => {
  window.yaCounter24094609 &&
    window.yaCounter24094609.reachGoal("perehod-nomer-zakupki-v-izveshchenii");
};

export const onOpenTenderFromCustomerYandex = () => {
  window.yaCounter24094609 &&
    window.yaCounter24094609.reachGoal("perehod-zakazchik-iz-izveshcheniya");
};

export const onTenderPlanApiTinkoffClick = () => {
  window.yaCounter24094609 &&
    window.yaCounter24094609.reachGoal("nastroit-tinkoff");
};

export const onTenderPlanApiTelegramClick = () => {
  window.yaCounter24094609 &&
    window.yaCounter24094609.reachGoal("podklyuchit-tg");
};

export const onTenderPlanApiOpenApiClick = () => {
  window.yaCounter24094609 &&
    window.yaCounter24094609.reachGoal("nastroit-openai");
};

export const onTenderPlanApiBitrixClick = () => {
  window.yaCounter24094609 &&
    window.yaCounter24094609.reachGoal("podklyuchit-bitrix");
};

export const onClickBuy = montsCount => {
  window.yaCounter24094609 &&
    window.yaCounter24094609.reachGoal(`oplatit-${montsCount}mes`);
};

export const onExportExcelKeyFormYandex = () => {
  window.yaCounter24094609 &&
    window.yaCounter24094609.reachGoal("vygruzit-excel");
};

export const onKeyFormAnalticsListTabChangeYandex = setName => {
  const map = {
    actual: "aktualnye-zakazy",
    closed: "zavershennye-zakazy",
    future: "plan-grafik",
    participants: "podryadchiki",
    customers: "zakazchiki",
    products: "tovar"
  };

  const resultGoal = map?.[setName];

  window.yaCounter24094609 &&
    resultGoal &&
    window.yaCounter24094609.reachGoal(resultGoal);
};

export const onOpenFiltersCentralPanelYandex = () => {
  window.yaCounter24094609 && window.yaCounter24094609.reachGoal("eshche");
};

export const onClickPayYandex = method => {
  const payMethodMap = {
    qr: "klik_oplatit_qr",
    card: "klik_oplatit_kartoi"
  };

  const yandexGoalByMethod = payMethodMap?.[method];

  if (yandexGoalByMethod) {
    window.yaCounter24094609 &&
      window.yaCounter24094609.reachGoal(yandexGoalByMethod);
  }
};
